export function mapAccountsError(code: string): string {
  switch (code) {
    case "DUPLICATE_DATE":
      return "accounts.errors.duplicate_date";
    case "FUTURE_DATE":
      return "accounts.errors.future_date";
    case "HAS_BALANCES":
      return "accounts.errors.has_balances";
    case "VALIDATION_ERROR":
      return "accounts.errors.validation";
    case "NOT_FOUND":
      return "accounts.errors.not_found";
    case "AUTHENTICATION_ERROR":
      return "errors.unauthenticated";
    default:
      return "errors.unknown";
  }
}
